module.exports = __webpack_public_path__ + "static/media/obiwan.69ca260a.jpg";